(function () {
  function formatRemaining(ms) {
    var totalSeconds = Math.floor(ms / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var parts = [];
    if (days > 0) parts.push(days + 'd');
    parts.push(hours + 'h');
    parts.push(minutes + 'm');
    parts.push(seconds + 's');
    return parts.join(' ');
  }

  function initCountdown(el) {
    var endTime = new Date(el.getAttribute('data-countdown-end')).getTime();
    if (isNaN(endTime)) return;

    function tick() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        var slide = el.closest('.slideshow__slide, .announcement-bar');
        if (slide) {
          slide.style.display = 'none';
          var slideshowEl = slide.closest('slideshow-component');
          if (slideshowEl && typeof slideshowEl.initPages === 'function') {
            slideshowEl.initPages();
          }
        }
        clearInterval(timer);
        return;
      }
      el.textContent = formatRemaining(remaining);
    }

    tick(); // run immediately to avoid 1s flash
    var timer = setInterval(tick, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-countdown-end]').forEach(initCountdown);
  });
})();
